"use client"

import { useEffect } from "react"
import "./partnerStyle.css"

export default function ProfileDialog({ open, onOpenChange, profile, title = "Partner Profile" }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onOpenChange(false)
    }
    if (open) {
      document.body.style.overflow = "hidden"
      window.addEventListener("keydown", onKey)
    }
    return () => {
      document.body.style.overflow = "unset"
      window.removeEventListener("keydown", onKey)
    }
  }, [open, onOpenChange])

  const rows = [
    { label: "Name", value: profile?.name || profile?.username || "N/A" },
    { label: "Email", value: profile?.email || "N/A" },
    { label: "Company", value: profile?.mainUserCompany || profile?.company_name || "N/A" },
    { label: "GSTIN", value: profile?.mainUserGST || profile?.gstin || "N/A" },
    { label: "PAN", value: profile?.mainUserPAN || profile?.pan || "N/A" },
    { label: "Assigned By", value: profile?.assignedBy || "Main User" },
  ]

  if (!open) return null

  return (
    <div className="ps-dialog-backdrop" onClick={() => onOpenChange(false)}>
      <div 
        className="ps-profile-modal" 
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="profile-title"
      >
        {/* Glow Effect */}
        <div className="modal-glow"></div>

        <div className="ps-dialog-header">
          <div className="header-avatar">
            {profile?.name?.[0]?.toUpperCase() || "P"}
          </div>
          <h2 id="profile-title" className="ps-modal-title">
            {title}
          </h2>
          <p className="ps-subtitle">Your partner account details</p>
        </div>

        <div className="ps-dialog-body">
          <div className="profile-grid">
            {rows.map((row) => (
              <div key={row.label} className="profile-row">
                <span className="profile-label">{row.label}</span>
                <span className="profile-value">{row.value}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="ps-dialog-actions">
          <button 
            className="ps-btn ps-btn-primary"
            onClick={() => onOpenChange(false)}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  )
}